var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.areaMap),function(room,area){return _c('a',{key:area,on:{"click":function($event){return _vm.navigateToArea(area, room)}}},[_c('SvgIcon',{staticClass:"clickable linkIconHeight",attrs:{"src":area}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }